export const consoleBuildInfo = () => {
	console.group('Build Info');
	console.log('project:', 'Quility Q2A HQ');
	console.log('date:', process.env.VUE_APP_GIT_DATE);
	console.log('commit:', process.env.VUE_APP_GIT_COMMIT_HASH);
	console.log('branch:', process.env.VUE_APP_GIT_BRANCH);
	console.groupEnd();
}
